const appLanguages = [
  {
    key: "en-GB",
    label: "English",
  },
  {
    key: "it-IT",
    label: "Italian",
  },
  {
    key: "es-ES",
    label: "Spanish",
  },
];

export const legacyAppLanguages = [
  {
    key: "fr-FR",
    label: "French",
  },
];

export const DEFAULT_APP_LANGUAGE_CODE = "en";

const languageCode = (tag?: string | null) =>
  (tag ?? "").toLowerCase().split(/[-_]/)[0];

export const PICKABLE_APP_LANGUAGE_CODES = appLanguages.map(({ key }) =>
  languageCode(key),
);

export const SUPPORTED_APP_LANGUAGE_CODES = [
  ...appLanguages,
  ...legacyAppLanguages,
].map(({ key }) => languageCode(key));

export const toAppLanguageCode = (tag?: string | null): string => {
  const code = languageCode(tag);
  return SUPPORTED_APP_LANGUAGE_CODES.includes(code)
    ? code
    : DEFAULT_APP_LANGUAGE_CODE;
};

export const getAppLanguageOptions = (current?: string | null) => {
  const code = toAppLanguageCode(current);
  const legacy = legacyAppLanguages.find(
    ({ key }) => languageCode(key) === code,
  );
  return legacy ? [...appLanguages, legacy] : appLanguages;
};

export default appLanguages;
